// src/usage.ts
import z from "zod";
var UsageProductSchema = z.enum(["http", "webSockets", "webhooks"]);
var UsageActionUnit = z.enum(["USD", "CU"]);

export {
  UsageProductSchema,
  UsageActionUnit
};
//# sourceMappingURL=chunk-5GQWIETG.mjs.map